<template>
    <div class="wrapper mt-3">
        <p>Ein Vertreter kann nur die Artikel aus den zugeordneten Sortimenten sehen. Ist kein Soritment zugeordnet, kann der Vertreter alle Artikel sehen. Für eine feinere Einstellung der Filter oder Anpassungen der Daten je Vertreter fragen Sie unsere Technik.</p>
        <p>Für die Aktivierung beim bShop muss einmal die Konfiguration abgeglichen werden. Dies geschieht automatisch einmal täglich, oder kann manuel in der bShop Admin UI durchgeführt werden.</p>
        <div class="row mt-3">
            <div class="col">
                <h5>Zugeordnete Sortimente</h5>
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="s in userlist" :key="s.map_id">
                        <span>{{ s.sort_id }}</span>
                        <button @click="remSelection(s)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
                    </li>
                </ul>
            </div>
            <div class="col">
                <h5>ERP Sortimente</h5>
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="s in sortlist" :key="s.map_id">
                        <span>{{ s.name }}</span>
                        <button @click="addSelection(s.map_id)" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import articles   from '@/modules/articles.js'
import ihandusers from '@/modules/ihanduser.js'

export default {
    name: 'iHandUserSelections',
    props: ["handid"],
    data() {
        return {
            userlist: [],
            sortlist: []
        }
    },
    watch: {
        handid: function(val) {
            console.log('updated handid',this.handid,val);
            if (val && val !== '') {
                this.fetchData();
            }
        }
    },
    mounted() {
      this.fetchSorts();
    },
    methods: {
        // soritment vom aktuellen vertreter entfernen
        remSelection(entry) {
          console.log('rem entry',entry);
          var self = this;
          ihandusers.deleteselection(this.handid,entry.map_id).then(function(resp) {
            if (resp.status !== 200) {
              resp.text().then(function(text) {
                self.$bvToast.toast('Fehler aufgetreten beim Löschen: ' + text,{variant:'danger',title:'Sortimente'});
              })
            }
            self.fetchData();
          });
        },
        // sortiment dem aktuellen vertreter hinzufügen
        addSelection(map_id) {
            var self  = this;
            var entry = { "hand_id": this.handid,"sort_id":map_id,"map_id": this.handid + '_' + map_id };
            console.log('save entry:',entry);
            ihandusers.saveselection(entry).then(function(resp) {
              if (resp.status !== 200) {
                resp.text().then(function(data) {
                  self.$bvToast.toast('Fehler bei den Vertretersortimenten: ' + data,{variant: 'danger',title:'Sortimente'})                  ;
                })
              } else {
                console.log('selection saved');
                self.fetchData();
              }
            }).catch(function(data) {
                console.error('Fehler bei Vertretersortimente laden: ',data);
                self.$bvToast.toast('Fehler bei den Vertretersortimenten: ' + data,{variant: 'danger',title:'Sortimente'})                  ;
            });
        },
        // laden der allgemeinen sortimentsliste
        fetchSorts() {
            var self = this;
            articles.searchSelections(this,0,1000,'',function(data) {
                console.log('sortiment liste',data);
                self.sortlist = data;
            });
        },
        // laden der vertreter sortimente
        fetchData() {
            var self = this;
            ihandusers.listselections(this.handid,0,500).then(function(data) {
                self.userlist = data;
            }).catch(function(err) {
                console.error('Fehler bei Vertretersortimente laden: ' + err);
            })
        }
    }
}
</script>
